import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../Context";
import { ProfileView } from "../../views/index";
import { ModalUtil } from "../../pures";
import { LocalStorageService, UserService, Auth0Service } from "../../../services";
import { useTranslation } from "react-i18next";
import { DefaultUserImage, } from "../../../assets/logos/icons"
import "moment/locale/es";
import { useHistory } from "react-router-dom";
import { PasswordValidator, ProfileValidator } from "../../../validators";

const ProfileAction = () => {
  const userService = new UserService(process.env.REACT_APP_ETICKET_API)
  const modalUtil = new ModalUtil();
  const history = useHistory()
  const { t } = useTranslation();
  const { t: transl, i18n } = useTranslation("profile");
  const { setShowError } = useContext(Context);
  const localStorageService = new LocalStorageService();

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    userFullName: "",
    firstName: "",
    firstLastName: "",
    secondLastName: "",
    userMail: "",
    userPhone: "",
    userPathImage: ""
  })

  const [showPasswordDialog, setShowPasswordDialog] = useState(false)
  const [passwordErrorMessage, setPasswordErrorMessage] = useState()
  const [showPhoneDialog, setShowPhoneDialog] = useState(false)
  const [phoneErrorMessage, setPhoneErrorMessage] = useState()

  // NUEVO: Estados para el modal de asistente
  const [showAssistantDialog, setShowAssistantDialog] = useState(false)
  const [currentAssistant, setCurrentAssistant] = useState(null)
  const [assistantsList, setAssistantsList] = useState([])
  const [tabSelected, setTabSelected] = useState('personalInfo')
  const [tabs, setTabs] = useState([]) // Cambia a estado


   useEffect(() => {
    const updatedTabs = [
      {
        route: 'personalInfo',
        title: transl("tabs.personalInfo"),
        key: 'tabs.personalInfo',
        selected: (tabSelected === 'personalInfo') ? true : false
      }, {
        route: 'preferences',
        title: transl("tabs.preferences"),
        key: 'tabs.preferences',
        selected: (tabSelected === 'preferences') ? true : false
      }
    ]
    setTabs(updatedTabs)
  }, [i18n.language, tabSelected, transl])

  const updateTabStatus = (tabSelected) => {
      setTabSelected(tabSelected)
    }

  const onSubmitChangeUserPassword = async (password, confirmPassword) => {
    const validator = PasswordValidator(t);
    const auth0Service = new Auth0Service();
    const token = JSON.parse(localStorage.getItem('token')).idToken

    let passwordValue = password?.trim();
    let confirmPasswordValue = confirmPassword?.trim();

    // Validate that both passwords are provided
    if (!passwordValue || !confirmPasswordValue) {
      setPasswordErrorMessage(transl("profile.error.allFields"))
      return;
    }

    // Validate that both passwords are equal
    if (!(passwordValue === confirmPasswordValue)) {
      setPasswordErrorMessage(transl("profile.error.passwordsMatch"))
      return;
    }

    // Validate if the password is secure
    const passwordValid = validator.passwordValidator(passwordValue);
    if (passwordValid !== "") {
      setPasswordErrorMessage(transl("profile.error.passwordNotSecure"))
      return;
    }

    try {
      setShowPasswordDialog(false);
      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))

      // Calling service to change password
      let changePassword = await auth0Service.changePasswordRequest(
        confirmPasswordValue,
        token
      );
      if (!(Number(changePassword.data.statusCode) === 200))
        throw new Error(transl("profile.error.passwordError"));

      modalUtil.showModal('success', transl("profile.success.password"), t("modal.pure.title.success"))
    } catch (error) {
      console.log(error)
      modalUtil.showModal('error', transl("profile.error.passwordError"), t("modal.pure.title.error"));
    }
  };

  /**
   * @author Brayan Salas
   *
   * @param {*} phoneNumber
   * @memberof ProfileAction
   */
  const onSubmitUpdatePhoneNumber = async (phoneNumber) => {
    const token = JSON.parse(localStorage.getItem('token')).idToken
    const validator = ProfileValidator(t);

    // Validate phoneNumber
    let phoneNumberValid = validator.phoneNumberValidator(phoneNumber);
    if (phoneNumber === undefined || phoneNumber.trim() === "" || phoneNumberValid !== "") {
      setPhoneErrorMessage(transl("profile.error.invalidPhone"))
      return;
    }

    try {
      setShowPhoneDialog(false);
      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))

      // Calling service to change password
      let updatePhoneNumber = await userService.updatePhoneNumber(phoneNumber, token);

      if ((Number(updatePhoneNumber.statusCode) !== 200))
        throw new Error(transl("profile.error.phoneError"));

      // Update user in local storage
      setUserData(prev => ({ ...prev, userPhone: phoneNumber }))
      const newUserData = localStorageService.getLocalStorageItem("user");
      newUserData.userMetaData.userA3Cloud.phoneNumber = phoneNumber
      localStorageService.setLocalStorageItem("user", newUserData)

      modalUtil.showModal('success', transl("profile.success.phone"), t("modal.pure.title.success"))
    } catch (error) {
      console.log(error)
      modalUtil.showModal('error', transl("profile.error.phoneError"), t("modal.pure.title.error"));
    }
  };

  // NUEVO: Manejar cambio de asistente por defecto
  const onSubmitUpdateAssistant = async (selectedAssistantId) => {
    try {
      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))

      // Buscar el asistente seleccionado
      const selectedAssistant = assistantsList.find(bot => bot.id === selectedAssistantId);
      
      if (!selectedAssistant) {
        throw new Error("Assistant not found");
      }

      // Llamar al backend para actualizar
      const token = JSON.parse(localStorage.getItem('token')).idToken
      await userService.updateDefaultBot(selectedAssistantId, token)

      // Actualizar en localStorage solo si la llamada fue exitosa
      const userData = localStorageService.getLocalStorageItem("user");
      userData.userMetaData.userA3Cloud.defaultBotConfigId = selectedAssistantId;
      localStorageService.setLocalStorageItem("user", userData);

      // Actualizar estado
      setCurrentAssistant(selectedAssistant);

      modalUtil.showModal('success', transl("profile.success.assistant"), t("modal.pure.title.success"))
      setShowAssistantDialog(false)
    } catch (error) {
      console.log(error)
      modalUtil.showModal('error', error.message || transl("profile.error.assistantError"), t("modal.pure.title.error"));
    }
  };

  const getUserData = async () => {
    setLoading(true)
    const user = localStorageService.getLocalStorageItem("user");
    const newImage = localStorageService.getLocalStorageItem("newImage");

    let userInformation = user.userMetaData.userA3Cloud;
    let phoneValue = "";
    if (userInformation.phoneNumber === null || userInformation.phoneNumber.trim() === "") {
      phoneValue = "";
    } else {
      phoneValue = userInformation.phoneNumber;
    }

    let fullName = `${userInformation.firstName} ${userInformation.firstLastName} ${userInformation.secondLastName ? userInformation.secondLastName : ""}`;
    let mail = `${userInformation.email}`;
    let image;

    if (newImage) {
      image = newImage
    } else {
      if (userInformation.profilePicture) {
        image = userInformation.profilePicture;
      } else {
        image = user.userMetaData.userAuth0.picture;
      }
    }

    // NUEVO: Cargar asistentes y obtener el seleccionado actualmente
    try {
      const token = JSON.parse(localStorage.getItem('token')).accessToken
      const clientId = userInformation.userA3Cloud?.clientId || userInformation.clientId
      const assistants = await userService.getAssistants(clientId, token)
      setAssistantsList(assistants)

      const currentBotId = userInformation.defaultBotConfigId || null
      const currentBot = assistants.find(bot => bot.id === currentBotId)
      setCurrentAssistant(currentBot || null)
    } catch (error) {
      console.error('Error loading assistants:', error)
    }

    try {
      setUserData({
        userFullName: fullName,
        userPhone: phoneValue,
        userPathImage: image || DefaultUserImage,
        userMail: mail,
        rfc: userInformation.rfc,
        firstName: userInformation.firstName,
        firstLastName: userInformation.firstLastName,
        secondLastName: userInformation.secondLastName
      });
    } catch (error) {
      history.push("/");
      return;
    }
    setLoading(false)
  }

  const togglePasswordDialog = () => {
    setShowPasswordDialog(prev => !prev)
    setPasswordErrorMessage("")
  }

  const togglePhoneDialog = () => {
    setShowPhoneDialog(prev => !prev)
    setPhoneErrorMessage("")
  }

  // NUEVO: Toggle para modal de asistente
  const toggleAssistantDialog = () => {
    setShowAssistantDialog(prev => !prev)
  }

  useEffect(() => {
    getUserData()
  }, [])

  return (
    <ProfileView
      {...userData}
      loading={loading}
      onSubmitChangeUserPassword={onSubmitChangeUserPassword}
      onSubmitUpdatePhoneNumber={onSubmitUpdatePhoneNumber}
      showPasswordDialog={showPasswordDialog}
      togglePasswordDialog={togglePasswordDialog}
      passwordErrorMessage={passwordErrorMessage}
      setPasswordErrorMessage={setPasswordErrorMessage}
      showPhoneDialog={showPhoneDialog}
      togglePhoneDialog={togglePhoneDialog}
      phoneErrorMessage={phoneErrorMessage}
      setPhoneErrorMessage={setPhoneErrorMessage}
      showAssistantDialog={showAssistantDialog}
      toggleAssistantDialog={toggleAssistantDialog}
      currentAssistant={currentAssistant}
      assistantsList={assistantsList}
      onSubmitUpdateAssistant={onSubmitUpdateAssistant}
      tabs={tabs}
      tabSelected={tabSelected}
      updateTabStatus={updateTabStatus}
      language={i18n.language}
    />
  )
}

export { ProfileAction as default };
